import React from 'react';
import { Typography } from '@doveit/lego';
import { BasicSectionProps } from '../types';
import PageSection from '../../components/page-section/PageSection';
import Markdown from '../../components/markdown/Markdown';
import BasicStripe, { BasicStripeProps } from '../../components/basic-stripe-2/BasicStripe';
import ArticleMarkdown from '../../components/article-markdown/ArticleMarkdown';

export interface StripesSectionProps extends BasicSectionProps {
  items: BasicStripeProps[],
}

export const StripesSection: React.FC<StripesSectionProps> = ({
  title,
  content,
  items,
}) => (
  <PageSection>
    <PageSection.Wrapper>
      {title && (
        <PageSection.Title>
          <Markdown>
            {title.trim()}
          </Markdown>
        </PageSection.Title>
      )}
      {content && (
        <PageSection.Block>
          <Typography.BODY>
            <ArticleMarkdown>
              {content.trim()}
            </ArticleMarkdown>
          </Typography.BODY>
        </PageSection.Block>
      )}
      {items.map((item, i) => (
        <PageSection.Block
          key={item.title}
          noSpacing={i === 0 && (!title && !content)}
        >
          <BasicStripe {...item} />
        </PageSection.Block>
      ))}
    </PageSection.Wrapper>
  </PageSection>
);

export default StripesSection;
